import { Link } from "react-router-dom";

type Crumb = { label: string; to?: string };

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-sm text-foreground-500">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, idx) => (
          <li key={item.label} className="flex items-center gap-2">
            {item.to ? (
              <Link to={item.to} className="transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.label}</span>
            )}
            {idx < items.length - 1 && (
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}